// Calendar selections represent local calendar days, including the entire last day.
export function reportDate(value) {
    if (!value) return null;
    const date = typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)
        ? new Date(value + 'T00:00:00') : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}

export function inReportDateRange(value, startDate, endDate) {
    if (!startDate && !endDate) return true;
    const date = reportDate(value);
    if (!date) return false;
    const start = reportDate(startDate);
    const end = reportDate(endDate);
    if (start) start.setHours(0, 0, 0, 0);
    if (end) end.setHours(23, 59, 59, 999);
    return (!start || date >= start) && (!end || date <= end);
}

export function filterFailureRows(rows, filters) {
    return rows.filter((row) => inReportDateRange(row.date, filters.startDate, filters.endDate)
        && ['failureType', 'serviceArea', 'route', 'machineType'].every((key) => !filters[key] || row[key] === filters[key])
        && ['customer', 'machineId'].every((key) => !filters[key]?.trim()
            || String(row[key] ?? '').toLowerCase().includes(filters[key].trim().toLowerCase())));
}
